export const langPath = (slug: string) => {
    const paths = slug.split("_");
    if (paths.length > 1) {
        //language path
        return `${paths[0]}/${paths[1]}`;
    } else return paths[0];
};

export const slugPath = (slug: string) => {
    const languages = JSON.parse(process.env.GATSBY_LANGUAGES || "[]");
    for (let i = 1; i < languages.length; i++) {
        if (slug.includes(`${languages[i]}_`)) {
            const paths = slug.split(`${languages[i]}_`);
            if (paths.length > 1) {
                return paths[1];
            } else return paths[0];
        }
    }
    return slug;
};
